import { render, staticRenderFns } from "./ImportButton.vue?vue&type=template&id=4e5c6154&scoped=true"
import script from "./ImportButton.vue?vue&type=script&lang=ts"
export * from "./ImportButton.vue?vue&type=script&lang=ts"
import style0 from "./ImportButton.vue?vue&type=style&index=0&id=4e5c6154&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5c6154",
  null
  
)

export default component.exports